<template>
  <div class="notifications">
    <div id="intro" class="notifications parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/montagnes.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.3"><img class=""  src="@/assets/images/rayons.png" alt="" title="" /></div>
        <div id="bg4" data-depth="0.1"><img class=""  src="@/assets/images/colines.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.6"><img class=""  src="@/assets/images/papillons.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container content-page notifications">
      <div class="grid-x grid-margin-x center">
        <div class="small-12 cell">
          <bouton href="dashboard" class-bt="return">Retour au carnet de bord</bouton>
          <title-page attrpage="Agenda" :baseline="`Retrouvez ici l'historique des rendez-vous de ${childName}`">Archive des rendez-vous</title-page>
        </div>

        <div class="small-12 cell">
          <div class="timeline">
            <div class="dot agenda end"></div>

            <item-appointment v-for="(appointment, i) in appointments" :appointment="appointment" :direction="i%2 == 0 ? 'right' : 'left'"></item-appointment>

            <div class="dot start"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import ItemAppointment from '@/components/ItemAppointment'
  import Pastille from '@/components/Pastille'
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton'
  import BadgesData from '@/datas/badges'

  const badgesIds = Object.keys(BadgesData).map(id => `badge_${id}`)

  export default {
    components: { Pastille, ItemAppointment, TitlePage, Bouton },
    data() {
      return {
        category: ""
      }
    },
    mounted () {
      this.resetNotificationsCount();
    },
    computed: {
      ...mapActions(['resetNotificationsCount']),
      ...mapGetters(['accountType','childName']),
      currentUser() {
        return this.$store.state.me
      },
      appointments() {
        return this.$store.state.appointments.slice().reverse();
      }
    }
  }
</script>
